import { Api } from "@/services/api.service";

export class TableReportsService {
  static async get402Form(contractRid: number, period: string) {
    const data = await Api.get("/electricity-report", {
      params: {
        contractRid,
        period,
      },
    });
    return data;
  }
}
